var map = {
	"./arcade.png": 8478,
	"./chat.png": 604,
	"./events.png": 7073,
	"./fish.png": 4752,
	"./follow.png": 4617,
	"./hot.png": 6293,
	"./inbox.png": 1576,
	"./live.png": 2064,
	"./poker.png": 9131,
	"./promotions.png": 8288,
	"./records.png": 3154,
	"./redeem.png": 4574,
	"./security.png": 6996,
	"./settings.png": 1961,
	"./signUpBonus.png": 5345,
	"./slot.png": 2966,
	"./sports.png": 1731,
	"./task.png": 7581,
	"./vip.png": 5977
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5849;